export const environment = {
  production: true,
  recaptchaSiteKey: '6LcqRJksAAAAAOAmNmaTNnjNq_7U_oJANt_lEH55',
  appCheckEnabled: true,
};
